<template>
    <div class="bd">

        <div class="my-custom-table">
            <a-page-header title="案例管理" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>案例名称：</a>
                    <a-input v-model:value="queryCaseName" placeholder="请输入案例名称进行搜索" class="search-input" />
                </div>
                <div class="tabInput">
                    <a>案例编号：</a>
                    <a-input v-model:value="queryCaseNo" placeholder="请输入案例编号进行搜索" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch" :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                    <div class="right-option">
                        <a-button type="primary" @click="toExport" :icon="h(DownloadOutlined)" ghost>导出</a-button>
                        <a-button type="primary" @click="toImport" :icon="h(UploadOutlined)">导入</a-button>
                        <a-button type="primary" @click="toAdd" :icon="h(PlusCircleOutlined)">添加</a-button>
                        <addComponent ref="childOpen" />
                        <editComponent ref="childEdit" />
                        <exportComponent ref="childExport" />
                        <importComponent ref="childImport" @import-success="handleImportSuccess" />
                    </div>
                </div>
            </div>
            <a-table :columns="columns" :data-source="data" :pagination="false" row-key="id">
                <template #bodyCell="{ column, text, record }">
                    <template v-if="column.key === 'status'">
                        <a-tag v-if="text === '正常'" color="green">{{ text }}</a-tag>
                        <a-tag v-else color="red">{{ text }}</a-tag>
                    </template>
                    <template v-if="column.key === 'caseNo'">
                        <a-tag color="blue">{{ text }}</a-tag>
                    </template>
                    <template v-if="column.key === 'caseName'">
                        <a-tooltip :title="text">
                            <span style="cursor: pointer; color: #1890ff;" @click="copyText(text)">{{ text }}</span>
                        </a-tooltip>
                    </template>
                    <template v-if="column.dataIndex === 'operation'">
                        <a @click="edit(record)">查看</a>
                        <a-popconfirm title="确认删除？" ok-text="是" cancel-text="否" @confirm="remove(record.id)">
                            <a style="margin: 15px;">删除</a>
                        </a-popconfirm>
                    </template>
                </template>
            </a-table>
            <div style="display: flex; justify-content: flex-end; margin-top: 16px;">
                <a-pagination
                    :current="pagination.current"
                    :total="pagination.total"
                    :page-size="pagination.pageSize"
                    show-size-changer
                    show-quick-jumper
                    :show-total="(total, range) => `第 ${range[0]}-${range[1]} 条，共 ${total} 条`"
                    @change="handlePaginationChange"
                    @show-size-change="handleSizeChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { taxCasePage, removeTaxCase } from '@/api/service';
import { cloneDeep } from 'lodash-es';
import { message } from 'ant-design-vue';
import { SearchOutlined, RedoOutlined, PlusCircleOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons-vue';
import { ref, h } from 'vue';
import addComponent from './modal/addComponent.vue';
import editComponent from './modal/editComponent.vue';
import exportComponent from './modal/exportComponent.vue';
import importComponent from './modal/importComponent.vue';

export default {
    name: 'TaxCasePage',
    components: {
        addComponent,
        editComponent,
        exportComponent,
        importComponent,
    },
    setup() {
        const data = ref([]);
        const queryCaseName = ref('');
        const queryCaseNo = ref('');
        const childOpen = ref(null);
        const childEdit = ref(null);
        const childExport = ref(null);
        const childImport = ref(null);
        const pagination = ref({
            current: 1,
            pageSize: 10,
            total: 0,
            showSizeChanger: true,
            showQuickJumper: true
        });

        const columns = [
            { title: '案例编号', dataIndex: 'caseNo', key: 'caseNo', width: '15%' },
            { title: '案例名称', dataIndex: 'caseName', key: 'caseName', width: '20%' },
            { title: '状态', dataIndex: 'status', key: 'status', width: '10%' },
            { title: '创建人', dataIndex: 'createBy', key: 'createBy', width: '10%' },
            { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt', width: '12%' },
            { title: '修改时间', dataIndex: 'updatedAt', key: 'updatedAt', width: '12%' },
            { title: '操作', dataIndex: 'operation', key: 'operation', width: '10%' },
        ];

        const list = async () => {
            const response = await taxCasePage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                caseName: queryCaseName.value,
                caseNo: queryCaseNo.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0;
                data.value = (response.data.records || []).map(item => ({
                    id: item.id,
                    caseNo: item.caseNo,
                    caseName: item.caseName,
                    status: item.status,
                    createBy: item.createBy,
                    createdAt: item.createdAt,
                    updatedAt: item.updatedAt,
                }));
            }
        };

        list();

        const handlePaginationChange = (page, pageSize) => {
            pagination.value.current = page;
            pagination.value.pageSize = pageSize;
            list();
        };

        const handleSizeChange = (current, size) => {
            pagination.value.current = 1;
            pagination.value.pageSize = size;
            list();
        };

        const deleteTaxCase = async (data) => {
            const response = await removeTaxCase(data);
            if (response.code === 200) {
                message.success('删除成功');
                return true;
            } else {
                message.error('删除失败' + response.msg);
                return false;
            }
        };

        const remove = async (id) => {
            const success = await deleteTaxCase(id);
            if (success) {
                data.value = cloneDeep(data.value.filter(item => id != item.id));
            }
        };

        const edit = (record) => {
            childEdit.value.openEdit(record);
        };

        const copyText = (text) => {
            navigator.clipboard.writeText(text).then(() => {
                message.success('已复制');
            }).catch(() => {
                message.error('复制失败');
            });
        };

        const onSearch = () => {
            pagination.value.current = 1;
            list();
        };

        const onReset = () => {
            queryCaseName.value = '';
            queryCaseNo.value = '';
            list();
        };

        const toAdd = () => {
            childOpen.value.open = true;
        };

        const toImport = () => {
            childImport.value.openImport();
        };

        const handleImportSuccess = () => {
            list();
        };

        const toExport = () => {
            childExport.value.openExport();
        };

        return {
            columns,
            pagination,
            data,
            queryCaseName,
            queryCaseNo,
            childOpen,
            childEdit,
            childExport,
            childImport,
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            DownloadOutlined,
            UploadOutlined,
            onSearch,
            onReset,
            toAdd,
            toImport,
            handleImportSuccess,
            toExport,
            h,
            ref,
            remove,
            edit,
            copyText,
            handlePaginationChange,
            handleSizeChange,
            list,
        };
    },
};
</script>
<style></style>